<template>
  <aside class="w-56 p-4 space-y-1 border-r border-gray-200 bg-white shrink-0">
    <ul role="list">
      <li
        v-for="item in pages" :key="item.id"
        @click="page = item.id"
      >
        <div
          class="text-gray-700 p-2 space-x-2 inline-block items-center flex cursor-pointer rounded-lg hover:bg-gray-100 border border-transparent font-medium"
          :class="page === item.id && 'text-blue-600 !bg-blue-50 hover:!border-transparent-200 font-bold'"
        >
          <span>
            <slot v-bind="item"></slot>
          </span>

          <span :class="page === item.id && 'font-semibold'">{{ item.name }}</span>
        </div>

        <ul
          v-if="item.children && item.children.length"

          class="ml-5 border-l border-gray-300 border-dashed"
          role="list"
        >
          <li
            v-for="subPage in item.children"
            :key="subPage.id"

            class="p-2 space-x-2 text-gray-700 items-center flex cursor-pointer rounded-lg hover:bg-gray-100 border border-transparent font-medium"
            :class="page === subPage.id && 'text-blue-600 !bg-blue-50 hover:!border-transparent-200 font-bold'"

            @click.stop="page = subPage.id"
          >
            <span>
              <slot v-bind="subPage"></slot>
            </span>

            <span :class="page === subPage.id && 'font-semibold'">
              {{ subPage.name }}
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </aside>
</template>

<script>

import queryParameters from "@/mixins/queryParameters"

export default {
  mixins: [queryParameters(['page'])],
  props: ['pages'],
  data() {
    return {
      page: this.pages[0].id,
    }
  },
  created() {
    this.$emit("input", this.page)
  },
  watch: {
    page() {
      this.$emit('input', this.page)
    },
  },
}

</script>
